import script from "./EditProductModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProductModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditProductModal.vue?vue&type=style&index=0&id=6e8b1f2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8b1f2e"]])

export default __exports__